import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Suspense } from 'react';
import { HStack, VStack } from '@/components/Layout';
import { Skeleton } from '@/components/ui/skeleton';
import { ItemDetailHeader } from './-layout/ItemDetailHeader';
export const Route = createFileRoute('/_staff/equipment/items/$id/_detail')({
  component: Layout
});
function ItemDetailHeaderSkeleton() {
  return <VStack className="gap-4 bg-neutral-fill px-12 pt-4 shadow-xs">
      <Skeleton className="h-5 w-64" />
      <VStack className="gap-2">
        <Skeleton className="h-6 w-16 rounded-full" />
        <HStack className="items-start justify-between gap-6">
          <VStack className="grow gap-2">
            <HStack className="items-baseline gap-3">
              <Skeleton className="h-8 w-48" />
              <Skeleton className="h-5 w-24" />
            </HStack>
            <Skeleton className="h-5 w-64" />
          </VStack>
          <VStack className="shrink-0 items-end gap-1">
            <Skeleton className="h-4 w-12" />
            <Skeleton className="h-8 w-16" />
          </VStack>
        </HStack>
      </VStack>
      <Skeleton className="h-10 w-full" />
    </VStack>;
}
function Layout() {
  return <VStack className="flex-1 min-h-0">
      <Suspense fallback={<ItemDetailHeaderSkeleton />}>
        <ItemDetailHeader />
      </Suspense>
      <Suspense>
        <Outlet />
      </Suspense>
    </VStack>;
}